import React from 'react';
import Icon, { ICON_TYPE } from '../base/icon';
import Layout from './layout';
import { Button, Logo, Typography } from '../base';
import BreadCrumb from './breadCrumb';

const Header = () => {
  return (
    <Layout.Header>
      <Layout.Container display={['flex']}>
        <Layout.HeaderLeft>
          <Logo />
        </Layout.HeaderLeft>
        <BreadCrumb>
          <BreadCrumb.Item>
            <Typography.Link href=".">Editor</Typography.Link>
          </BreadCrumb.Item>
          <BreadCrumb.Item>
            <Typography.Link href=".">Photo Books</Typography.Link>
          </BreadCrumb.Item>
          <BreadCrumb.Item>Hardcover Book</BreadCrumb.Item>
        </BreadCrumb>
        <Layout.HeaderRight>
          <Button
            display={['inline-block', 'inline-block', 'none']}
            textAlign="center"
            width={32}
            mr={[1, 1, 1]}
            p={0}
            variant="secondary"
          >
            <Icon type={ICON_TYPE.ADD} mr={0} width={8} height={8} />
          </Button>
          <Button variant="secondary" mr={[1, 1, 2]} display={['none', 'none', 'inline-block']}>
            <Icon type={ICON_TYPE.ADD} width={8} height={8} />
            Photos
          </Button>
          <Layout.HeaderTitle color="primary" borderColor="primary">
            $14.99
          </Layout.HeaderTitle>
          <Button variant="primary" display={['none', 'none', 'inline-block']}>
            Add to cart
          </Button>
          <Button
            variant="primary"
            textAlign="center"
            width={32}
            p={0}
            display={['inline-block', 'none', 'none']}
          >
            <Icon type={ICON_TYPE.BAG} mr={0} width={16} height={16} />
          </Button>
        </Layout.HeaderRight>
      </Layout.Container>
    </Layout.Header>
  );
};

export default Header;
